export default {
    gdpr: {
        banner: {
            title: 'Navigating on our website (cookie use)',
            description: 'We use cookies to make this site work and to help us make improvements. Clicking accept will enable us to set recommended analytics cookies.',
            accept: 'Accept',
            settings: 'Change cookie settings'
        },
        settings: {
            title: 'Navigating on our website (cookie use)',
            description: 'We use cookies to operate our site. We also use analytics cookies to help us improve the site over time. We will not set cookies unless you enable them. Using this tool will set a cookie on your device to remember your preferences. For more information on the cookies we use, please see our Privacy Statement page.',
            essentials: {
                title: 'Essential cookies',
                description: 'Essential cookies activate basic functionalities such as security, network management, and accessibility. You can disable them by modifying your browser settings, but this may affect the website’s performance.',
            },
            analytics: {
                title: 'Analytics cookies',
                description: 'We would like to set Google Analytics cookies to help us improve our website by collecting and reporting information about how you use the site. These cookies collect information completely anonymously. For more information on how these cookies work, please see our Privacy Statement page.',
            },
            save: 'Save and close'
        },
    }
}
